@if (tilvalg) {
  <h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Rediger tilvalg</h1>
}
@if (!tilvalg) {
  <h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Opret tilvalg</h1>
}
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select formControlName="tilvalgType">
          @for (group of tilvalgGroups; track group) {
            <mat-option [value]="group.shortname">{{ group.shortname }}</mat-option>
          }
        </mat-select>
        <mat-icon matSuffix class="select-arrow">keyboard_arrow_down</mat-icon>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Navn</mat-label>
        <input formControlName="name" matInput />
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Varenr</mat-label>
        <input formControlName="okKundeVarenr" matInput />
        <!-- <button type="button" mat-button *ngIf="vareInfoCollected" matSuffix mat-icon-button aria-label="Clear" (click)="clearVareInfo()">
        <mat-icon>close</mat-icon>
      </button> -->
        <mat-hint [matTooltip]="!vareInfoCollected ? 'Udfyld varenr. felt for at hente vareinfo' : ''">
          <button
            class="btn-icon"
            [class.blue]="!vareInfoCollected"
            [class.green]="vareInfoCollected"
            [disabled]="!okKundeVarenr.value"
            (click)="getInfoForVareNr(okKundeVarenr.value)"
          >
            @if (!vareInfoCollected) {
              <mat-icon svgIcon="download"></mat-icon>
            }
            @if (vareInfoCollected) {
              <mat-icon svgIcon="checkmark"></mat-icon>
            }
            @if (!vareInfoCollected) {
              <span>Hent vareinfo fra G4</span>
            }
            @if (vareInfoCollected) {
              <span>Vareinfo hentet fra G4</span>
            }
          </button>
        </mat-hint>
        @if (noVareInfoInG4) {
          <div class="red tiny-text">Varen findes ikke i G4 - eller har ingen pris i G4.</div>
        }
      </mat-form-field>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  @if (tilvalg) {
    <button mat-raised-button mat-raised-button color="warning" class="red margin--right-auto" (click)="delete()">
      <mat-icon svgIcon="delete" class="margin--right-s"></mat-icon>
      Slet
    </button>
  }
  <button mat-raised-button mat-dialog-close="">Fortryd</button>
  <button [disabled]="!form.valid" mat-raised-button color="primary" (click)="click()">Gem</button>
</div>
